import { toast } from "react-toastify";
import { axiosClient } from "../../../../config";
import { POST_REQUEST_SIGNATURE_URL } from "../../../../utilities/constants";
import { addAdditionalDriver, editAdditionalDriver, removeAdditionalDriver, resetAD, setAdditionalDriverSignature, setLimit } from "./additionalDriverSlice";
import i18n from "../../../../config/lang";
import { drawSignature, setSignatureSize } from "../../../../utilities";

const t = i18n.t;

export const startInitADLimit = ({ limit }) => {
    return async( dispatch ) => {
        dispatch( setLimit(limit) );
    }
}

export const startAddADToList = (additionalDriver) => {
    return async( dispatch ) => {
        try {
            dispatch( addAdditionalDriver(additionalDriver) );
            return true;
        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false
        }
    }
}

export const startUpdateADFromList = (id, additionalDriver) => {
    return async( dispatch ) => {
        try {
            dispatch( editAdditionalDriver({ id, info: additionalDriver }) );
            return true;
        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false
        }
    }
}

export const removeAddFromList = ({ id }) => {
    return async( dispatch ) => {
        dispatch( removeAdditionalDriver(id) );
    }
}

export const startADRequestSignature = ({ id, pinpadId, officeId }) => {
    return async ( dispatch ) => {
        try {
            const { status: statusResponse, data: response } = await axiosClient.post(POST_REQUEST_SIGNATURE_URL,
                {
                    PinPadID: pinpadId,
                    Office: officeId,
                    SignatureOnly: true
                },
                {
                    timeout: 90000
                }
            )
            .catch(e => e);

            if (statusResponse != 200 || response?.type != "success") {
                toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
                return false;
            }

            const signatureData = response.data;

            const renterSignature = JSON.parse(signatureData.renterSignature)?.additionalData?.responseData;

            const renterSignaturePoints = !!renterSignature ? JSON.parse(renterSignature).signature.data: null;

            const imageSize = setSignatureSize(renterSignaturePoints);

            const svgDescription = drawSignature(renterSignaturePoints, imageSize);

            dispatch(
                setAdditionalDriverSignature({
                    id,
                    renterSignaturePoints,
                    svgDescription
                })
            );

        } catch (error) {
            console.error(error);
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
        }
    }
}

export const startADRequestSignatureForm = ({ pinpadId }) => {
    return async () => {
        try {
            const { status: statusResponse, data: response } = await axiosClient.post(POST_REQUEST_SIGNATURE_URL,
                {
                    PinPadID: pinpadId,
                    Office: OFFICE.id,
                    SignatureOnly: true
                },
                {
                    timeout: 90000
                }
            )
            .catch(e => e);

            if (statusResponse != 200 || response?.type != "success") {
                toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
                return false;
            }

            const signatureData = response.data;

            const renterSignature = JSON.parse(signatureData.renterSignature)?.additionalData?.responseData;

            const renterSignaturePoints = !!renterSignature ? JSON.parse(renterSignature).signature.data: null;

            return renterSignaturePoints;
        } catch (error) {
            console.error(error);
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}

export const startResetAD = () => {
    return async ( dispatch ) => {
        try {
            dispatch( resetAD() );
        } catch (error) {
            console.error(error);
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}
